export default "__VITE_ASSET__BVLgtNgO__"